module.exports = __webpack_public_path__ + "static/media/Buzz4.ac9a177a.jpg";